import { Component } from "@angular/core";
import { ActiveNavSectionService } from "@app2/shared/services/active-nav-section.service";

@Component({
    selector: "navigation-top-bar-home",
    template: `
        <nav class="top-bar no-border" role="navigation">
            <section class="top-bar-section nav-section-main">
                <ul class="left">
                    <li class="nav-top-item-main main-item-no-link">
                        {{ "CYBER_RISK_READINESS_DASHBOARD" | localize }}
                    </li>
                </ul>
            </section>
        </nav>
    `,
})
export class NavigationTopBarHomeComponent {
    constructor(public navSectionService: ActiveNavSectionService) {
    }
}
